import React from 'react';

import type { BrainAtlasType, MultiLang } from '../../../config';
import Functions from '../../../functions';
import type { Item } from '../../lib/ItemUtil';

export interface DetailBaseField {
    label: string;
    value: React.ReactNode;
}

export interface DetailBaseProps {
    lang: MultiLang;
    item: Item;
    type: BrainAtlasType;
}

class DetailBase extends React.Component<DetailBaseProps> {
    getFields(): DetailBaseField[] {
        return [];
    }

    render() {
        const { lang } = this.props;
        const elements = this.getFields().map((value, idx) => {
            const evenodd = idx % 2 === 0 ? 'even' : 'odd';
            return (
                <tr key={value.label}>
                    <td className="head">{Functions.mlang(value.label, lang)}</td>
                    <td className={evenodd}>{value.value}</td>
                </tr>
            );
        });
        return (
            <table className="outer itemDetail">
                <tbody>{elements}</tbody>
            </table>
        );
    }
}

export default DetailBase;
